import { render } from "./PlatformNotifications.vue?vue&type=template&id=c6c39506"
import script from "./PlatformNotifications.vue?vue&type=script&lang=js"
export * from "./PlatformNotifications.vue?vue&type=script&lang=js"

import "./PlatformNotifications.vue?vue&type=style&index=0&id=c6c39506&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__